/* Translates input from the browser into game actions */
class InputHandler {
  constructor({
    document,
    onLeft,
    onRight,
    onUp,
    onDown,
    onAny,
    log
  }) {
    this.log = log.forClass("InputHandler")

    this.onAny   = onAny   ? onAny   : (event) => {}
    this.onLeft  = onLeft  ? onLeft  : (event) => {}
    this.onRight = onRight ? onRight : (event) => {}
    this.onUp    = onUp    ? onUp    : (event) => {}
    this.onDown  = onDown  ? onDown  : (event) => {}

    document.querySelectorAll("[data-message]").forEach( (element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault()
        const logger = this.log.method("click message")
        this.onAny(event)
        logger.end()
      })
    })

    document.addEventListener("keydown", (event) => {
      const logger = this.log.method("keydown")
      const continueHandling = this.onAny(event)
      logger.addDetails({ continueHandling: continueHandling })
      if (!continueHandling) {
        logger.end()
        return;
      }
      if ((event.key == "h") || (event.key == "ArrowLeft")) {
        logger.addDetails({ direction: "left", key: event.key })
        this.onLeft()
      }
      else if ((event.key == "j") || (event.key == "ArrowDown")) {
        logger.addDetails({ direction: "down", key: event.key })
        this.onDown()
      }
      else if ((event.key == "k") || (event.key == "ArrowUp")) {
        logger.addDetails({ direction: "up", key: event.key })
        this.onUp()
      }
      else if ((event.key == "l") || (event.key == "ArrowRight")) {
        logger.addDetails({ direction: "right", key: event.key })
        this.onRight()
      }
      else {
        logger.addDetails({ ignored: true })
      }
      logger.end()
    })

    const makeHandler = (element, direction) => {
      const functionName = `on${direction.charAt(0).toUpperCase() + direction.slice(1)}`
      element.addEventListener("click", (event) => {
        event.preventDefault()
        const logger = this.log.method(`click ${direction}`)
        const continueHandling = this.onAny(event)
        logger.addDetails({ continueHandling: continueHandling })
        if (continueHandling) {
          this[functionName]()
        }
        logger.end()
      })
    }

    document.querySelectorAll("[data-left-arrow]").forEach(  (element) => makeHandler(element, "left") )
    document.querySelectorAll("[data-down-arrow]").forEach(  (element) => makeHandler(element, "down") )
    document.querySelectorAll("[data-up-arrow]").forEach(    (element) => makeHandler(element, "up") )
    document.querySelectorAll("[data-right-arrow]").forEach( (element) => makeHandler(element, "right") )
  }
}

export default InputHandler
